<!-- Skip-link — first focusable element on the page for keyboard users -->
<!-- Adapted from vg-vgn.npm src/main/lib/components/global-header.scss -->
<a class="myce-header__skip-link" href="#main-content">
  <span class="english">Skip to main content</span>
  <span class="spanish hidden">Saltar al contenido principal</span>
</a>

<ng-container *ngIf="{ isOpen: (isMobileNavOpen$ | async) } as vm">
  <div class="myce-header" [class.myce-header--nav-open]="vm.isOpen">
    <!-- Row 1: Logo + utility actions (Contact us, Language, Log in) -->
    <xbh-header-utility></xbh-header-utility>

    <!-- Row 2: Primary navigation (desktop only; hidden via CSS on mobile) -->
    <xbh-header-nav></xbh-header-nav>

    <!-- Hamburger button — visible only on mobile (< LG) -->
    <button type="button"
            class="myce-header__hamburger"
            [attr.aria-label]="vm.isOpen ? closeNavAriaLabel : hamburgerAriaLabel"
            [attr.aria-expanded]="vm.isOpen"
            aria-controls="myce-mobile-nav-drawer"
            (click)="toggleMobileNav()">
      <ng-container *ngIf="vm.isOpen; else hamburgerIcon">
        <img src="/assets/icons/close.svg"
             aria-hidden="true"
             alt=""
             class="myce-header__hamburger-icon" />
      </ng-container>
      <ng-template #hamburgerIcon>
        <img src="/assets/icons/Nav_mob_menu.svg"
             aria-hidden="true"
             alt=""
             class="myce-header__hamburger-icon" />
      </ng-template>
    </button>
  </div>
</ng-container>

<!-- Grades sub-navigation panel (shown when user is on a grade page) -->
<grades-menu *ngIf="showGradesMenu" id="grades-menu-panel"></grades-menu>

<!-- Mobile slide-in drawer -->
<xbh-mobile-nav></xbh-mobile-nav>